import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";

import { TextField } from "@mui/material";
import shortid from "shortid";

const AddChoicesStep = ({ choices, onChange }) => {
  const [newChoices, setNewChoices] = useState(choices);

  return (
    <div>
      <div className="mt-6 w-full flex flex-col gap-4 items-center justify-center">
        {newChoices?.map((choice, index) => {
          return (
            <div className="flex items-center gap-4">
              <TextField
                key={choice.id}
                value={choice.value}
                onChange={(e) => {
                  const updated = [...newChoices];
                  updated[index] = { id: choice.id, value: e.target.value };
                  onChange(updated);
                  setNewChoices(updated);
                }}
              />
              <FaDeleteLeft
                title="Ջնջել"
                className="cursor-pointer"
                color="red"
                size={26}
                onClick={() => {
                  const updated = newChoices.filter((c) => c.id !== choice.id);
                  onChange(updated);
                  setNewChoices(updated);
                }}
              />
            </div>
          );
        })}
        <FaPlus
          onClick={() =>
            setNewChoices((prev) => [
              ...prev,
              { id: shortid.generate(), value: "" },
            ])
          }
          className="cursor-pointer"
          size={30}
          color="#7F7F7F"
        />
      </div>
    </div>
  );
};

export default AddChoicesStep;
